import { render, staticRenderFns } from "./FolderView.vue?vue&type=template&id=52fb359b&"
import script from "./FolderView.vue?vue&type=script&lang=ts&"
export * from "./FolderView.vue?vue&type=script&lang=ts&"
import style0 from "./FolderView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
